// Configurable holiday collections (filter over existing packages).
export const COLLECTIONS = {
  "flight-hotel": {
    title: "Flight + Hotel Holidays",
    subtitle: "Bundle your flights and hotel together and save — one price, one booking, zero hassle.",
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    match: () => true,
  },
  "city-breaks": {
    title: "City Breaks",
    subtitle: "Long weekends and short escapes to the world's most iconic cities.",
    image: "https://images.pexels.com/photos/16823629/pexels-photo-16823629.jpeg?auto=compress&cs=tinysrgb&w=2000",
    match: (p) => ["Paris", "Rome", "New York", "Tokyo", "Dubai", "London"].includes(p.destination),
  },
  "beach-holidays": {
    title: "Beach Holidays",
    subtitle: "Turquoise water, soft sand and sunshine — your perfect beach escape awaits.",
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    match: (p) => ["Maldives", "Bali", "Bangkok"].includes(p.destination),
  },
  "all-inclusive": {
    title: "All-Inclusive Holidays",
    subtitle: "Flights, hotel, meals and more — everything sorted so you can simply relax.",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    match: (p) => ["Maldives", "Dubai", "Bangkok"].includes(p.destination),
  },
  "family-holidays": {
    title: "Family Holidays",
    subtitle: "Space, comfort and fun for everyone — holidays the whole family will love.",
    image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    match: (p) => ["Bali", "Dubai", "Rome", "Bangkok"].includes(p.destination),
  },
  "last-minute": {
    title: "Last Minute Deals",
    subtitle: "Ready to go? Grab a great-value getaway — sorted in a tick.",
    image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    match: () => true,
    sortByPrice: true,
  },
};

export const COLLECTION_NAV = [
  ["/flight-hotel", "Flight + Hotel"],
  ["/city-breaks", "City Breaks"],
  ["/beach-holidays", "Beach Holidays"],
  ["/all-inclusive", "All-Inclusive"],
  ["/family-holidays", "Family Holidays"],
  ["/last-minute", "Last Minute Deals"],
];
